import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StockComponent } from './stock.component';
import { DashboardStockComponent } from './list/dashboard-stock/dashboard-stock.component';
import { ListStockComponent } from './list/list-stock.component';
import { StockFormComponent } from './stock-form/stock-form.component';

const routes: Routes = [
  {
    path: '',
    component: StockComponent, // ← PAI COM <router-outlet>
    children: [
      { path: '', component: DashboardStockComponent }, // ← rota padrão
      { path: 'list', component: ListStockComponent },
      { path: 'form', component: StockFormComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StockRoutingModule {}
